import { CommonModule, Location } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { environment } from '../../../environments/environment';
import { UIButton } from '../../shared/ui/button/button.component';
import { THEME } from '../../shared/utils/app.const';

@Component({
  standalone: true,
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss',
  imports: [CommonModule, RouterLink, UIButton],
})
export class PageNotFoundComponent {
  readonly isWealthOnline = environment.theme === THEME.WEALTH_ONLINE;
  readonly isOtto1890 = environment.theme === THEME.OTTO1890;

  constructor(private _location: Location) {}

  back(): void {
    this._location.back();
  }
}
